<template>
    <div>
        <el-dialog :title="title" top="5%" size="tiny" :visible.sync="editFormVisible" v-model="editFormVisible" :close-on-click-modal="false">
            <el-form ref="form" :model="form" :rules="rules" label-width="110px">
                <el-form-item label="上传Excel">
                    <sy-doc-upload v-model="form.FFileName" ></sy-doc-upload>
                </el-form-item>
            </el-form>
            <div class="download">
                <a href="javascript:;" @click="download()">下载模板</a>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editFormVisible = false">取 消</el-button>
                <el-button v-if="authEdit" type="primary" @click="save" :loading="loading">导入</el-button>
            </div>
        </el-dialog>
    </div>
</template>


<script>
    import util from '../../common/util'
    import mixin from '../../common/mixin'
    export default {
        mixins: [mixin],
        data() {
            return {
                title:"",
                authEdit:true,
                form: {},
                loading:false,
                editFormVisible:false
            }
        },
        methods: {
            _open(jobID) {
                this.title = "导入模板数据"
                this.editFormVisible = true;
                let form = {FID:0,FFileName:"",FMouldId:jobID};
                this.form = form
              
            },
            save:function () {
              if(this.form.FFileName==""){
                util.msgWarning("请上传要导入的文件")
                return
              }
                let that = this
                this.$confirm('导入数据将会覆盖原有的数据，确认导入吗?', '提示', {
                    //type: 'warning'
                }).then(()=>{
                    let url = "server/business/ProjectMould.ashx?cmd=ImportDetail"
                    util.saveForm(url,that.$refs.form,that.form,that.loadFn("loading"),result=> {
                    util.msgSuc("导入成功")
                    that.editFormVisible = false
                    that.$emit("onImportDetailSuc",that.form)
                })}).catch(() => {

                });
               
            },
            download(){
                window.open(global.serverHost+ "client/detail_import.xlsx")
            }
        },
        created() {

        }
    }
</script>


<style scope>
    .download{
        margin: 20px 120px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/business/ProjectMouldDetail_Import.vue